// extracted by css-extract-rspack-plugin
export default {"mapPaperStyled":"mapPaperStyled-GHMjkr"};